<div class="wrapper">
  <onyx-icon name="error-circle-two-tone-filled" [size]="32"></onyx-icon>

  <div class="text">
    <h4>{{ message() ?? `${I18N}.message` | translate }}</h4>
    <p class="f-body-s f-muted">{{ `${I18N}.description` | translate }}</p>
  </div>
</div>

<onyx-button color="red" (click)="error.set(false)">
  {{ `${I18N}.refresh` | translate }}
</onyx-button>
